import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      {...props}
      width={108}
      height={108}
      viewBox="0 0 108 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        stroke="#000"
        strokeOpacity={0.1}
        strokeWidth={0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.25 87.76h97.941"
      />
      <Path
        d="M34.588 67.51c-12.782 2.69-19.44 8.568-19.44 20.395H47.3V67.509H34.588z"
        fill="#CC003F"
      />
      <Path
        d="M60.011 67.51H47.299v20.395H79.45c0-11.827-6.692-17.705-19.439-20.396z"
        fill="#CC003F"
      />
      <Path
        d="M64.508 42.83l-1.38-.212c1.203-7.224.106-13.137-3.223-17.032-2.832-3.328-7.294-5.205-12.605-5.205-5.276 0-9.737 1.841-12.606 5.24-3.328 3.93-4.461 9.808-3.257 16.997l-1.381.212c-1.275-7.613-.036-13.88 3.576-18.13 3.151-3.682 8.003-5.7 13.633-5.7 5.736 0 10.587 2.018 13.703 5.665 3.576 4.25 4.815 10.517 3.54 18.165z"
        fill="#FFD7B3"
      />
      <Path
        d="M56.825 50.903v12.251c0 5.63-4.285 10.162-9.56 10.162V50.903h9.56z"
        fill="#EAC29D"
      />
      <Path
        d="M37.74 50.903v12.251c0 5.63 4.284 10.162 9.56 10.162V50.903h-9.56z"
        fill="#EAC29D"
      />
      <Path
        d="M33.924 43.357l-1.779-3.779c-.92.284-1.487 1.275-1.345 2.302l1.31 7.931c.177 1.098 1.169 1.842 2.195 1.665.177-.036.355-.106.496-.177 3.045 9.029 7.153 11.437 12.64 11.437l.361-32.06c-12.96-3.15-13.878 4.75-13.878 12.68z"
        fill="#FFD8BC"
      />
      <Path
        d="M31.968 39.856l2.337 4.249c0-7.896 0-16.324 12.995-13.172v-9.596c-11.402 0-16.323 7.719-15.332 18.519z"
        fill="#242424"
      />
      <Path
        d="M60.294 43.822l2.337-4.249c.921.283 1.488 1.275 1.346 2.302l-1.31 7.931c-.177 1.098-1.169 1.841-2.196 1.664a2.048 2.048 0 01-.495-.177c-3.045 9.03-7.153 11.437-12.641 11.437V30.877c12.96-3.151 12.96 5.014 12.96 12.945z"
        fill="#FFD8BC"
      />
      <Path
        d="M39.297 79.549l8.003-6.232-9.56-10.162-3.152 4.355 4.71 12.039zM55.266 79.549L47.3 73.317l9.525-10.162 3.187 4.355-4.745 12.039z"
        fill="#8B032D"
      />
      <Path
        d="M62.631 39.856l-2.337 4.249c0-7.896 0-16.324-12.995-13.172v-9.596c11.402 0 16.324 7.719 15.332 18.519zM27.825 46.123c.284 2.337 1.7 4.249 3.612 5.099l-1.31-10.87c-1.629 1.274-2.585 3.434-2.302 5.77z"
        fill="#242424"
      />
      <Path
        d="M31.437 51.222c.46.213.956.354 1.487.425.744.106 1.31-.602 1.204-1.345L32.995 40.6c-.106-.744-.78-1.31-1.487-1.027-.496.177-.921.46-1.346.779l1.275 10.87z"
        fill="#FF7A00"
      />
      <Path
        d="M66.74 46.123c-.284 2.337-1.7 4.249-3.613 5.099l1.31-10.87c1.63 1.274 2.585 3.434 2.302 5.77z"
        fill="#242424"
      />
      <Path
        d="M63.128 51.222c-.46.212-.956.354-1.487.425-.744.106-1.31-.602-1.204-1.346l1.168-9.666c.106-.744.78-1.31 1.487-1.027.496.177.92.46 1.346.779l-1.31 10.835z"
        fill="#FF7A00"
      />
      <Path
        d="M33.456 51.505a5.386 5.386 0 01-1.7-.355c2.054 4.958 7.648 8.144 14.624 8.144v-1.38c-5.95 0-10.8-2.515-12.925-6.41z"
        fill="#242424"
      />
      <Path
        d="M49.212 58.48c0 .957-.779 1.736-1.735 1.736h-2.195a1.738 1.738 0 01-1.735-1.735c0-.956.779-1.735 1.735-1.735h2.195c.956 0 1.735.779 1.735 1.735z"
        fill="#FF7A00"
      />
      <Path d="M90.782 53.818H70.103V78.78h20.679V53.818z" fill="#F2F2F2" />
      <Path
        d="M88.09 57.712h-7.294v.567h7.294v-.567zM88.09 59.518h-7.294v.567h7.294v-.567zM88.126 65.184h-7.294v.566h7.294v-.566zM88.126 66.99h-7.294v.566h7.294v-.566zM88.09 72.549h-7.294v.566h7.294v-.566zM88.09 74.355h-7.294v.566h7.294v-.567z"
        fill="#242424"
      />
      <Path
        d="M94.18 72.088l-.389-.035c.709.07 1.31-.425 1.381-1.133.071-.708-.425-1.31-1.133-1.416l-.425-.036c.708.071 1.31-.425 1.417-1.133.07-.708-.425-1.31-1.134-1.416l-5.736-.602c-.708-.071-1.31.425-1.416 1.133-.07.708.425 1.31 1.133 1.416l.425.036c-.708-.071-1.31.424-1.416 1.133-.071.708.424 1.31 1.133 1.38l.39.036c-.709-.07-1.31.425-1.417 1.133-.07.708.425 1.31 1.133 1.416l5.736.602c.708.071 1.31-.425 1.416-1.133.107-.672-.424-1.31-1.097-1.38z"
        fill="#EAC29D"
      />
      <Path
        d="M84.585 63.484l-.141.213 1.345 1.38.39-.53-1.594-1.063z"
        fill="#FCD87E"
      />
      <Path d="M83.452 62.706l.991.991.142-.212-1.133-.78z" fill="#242424" />
      <Path
        d="M86.178 64.546l.354-.566-1.77-.744-.177.248 1.593 1.062z"
        fill="#FFEC9C"
      />
      <Path
        d="M84.585 63.485l.177-.248-1.31-.531 1.133.779zM86.146 64.532l-.376.558 14.633 9.84.375-.559-14.632-9.84z"
        fill="#242424"
      />
      <Path
        d="M100.779 74.345l-.376.558 1.146.77.376-.558-1.146-.77z"
        fill="#CC003F"
      />
      <Path
        d="M86.554 63.977l-.375.559 14.606 9.816.375-.559-14.606-9.816z"
        fill="#242424"
      />
      <Path
        d="M101.162 73.814l-.376.558 1.146.77.375-.557-1.145-.771z"
        fill="#CC003F"
      />
      <Path
        d="M96.2 67.626v-.07c0-.072 0-.142-.036-.178v-.07a1.433 1.433 0 00-.708-.992l-5.276-1.912c-.708-.39-1.7-.354-2.09.354-.389.708.036 1.381.709 1.77l4.603 1.983-.07 3.046-1.842 2.761-.283-5.984c0-.991-.531-1.912-1.523-1.912-.991 0-1.593.744-1.593 1.735l-.213 8.746c0 .142 0 .248.036.354h-.036l2.444 10.517h7.4l-2.868-6.445 1.877-6.55v-.567l-.532-6.586z"
        fill="#FFD7B3"
      />
      <Path
        d="M74.92 56.107c-.845 0-1.533.688-1.533 1.533h.614a.921.921 0 011.84 0c0 .328-.14.45-.455.692-.117.09-.249.192-.376.318-.402.402-.398.799-.396.83v.614h.613v-.617c0-.007.007-.184.217-.393.098-.098.21-.184.316-.266.325-.25.694-.534.694-1.178 0-.845-.688-1.533-1.533-1.533zm-.306 4.293h.613v.614h-.613V60.4zM74.92 63.467c-.845 0-1.533.688-1.533 1.534h.614a.921.921 0 011.84 0c0 .328-.14.449-.455.691a3.76 3.76 0 00-.376.319c-.402.401-.398.798-.396.83v.613h.613v-.616c0-.007.007-.184.217-.394.098-.098.21-.183.316-.266.325-.25.694-.533.694-1.177 0-.846-.688-1.534-1.533-1.534zm-.306 4.294h.613v.613h-.613v-.613zM74.92 70.827c-.845 0-1.533.688-1.533 1.534h.614a.921.921 0 011.84 0c0 .327-.14.449-.455.691-.117.09-.249.192-.376.318-.402.402-.398.799-.396.83v.614h.613v-.616c0-.008.007-.184.217-.394.098-.098.21-.183.316-.266.325-.25.694-.534.694-1.177 0-.846-.688-1.534-1.533-1.534zm-.306 4.294h.613v.613h-.613v-.613z"
        fill="#CC003F"
      />
    </Svg>
  );
}

export default SvgComponent;
